// 利用規約のチェックボックスと送信ボタンの制御

$(window).on('load', () => {
  // ロード時に一瞬スタイルが適用されない問題を防ぐ
  const termWindow = $('#term-window')
  const agreeCheck = $('#agree')
  const button = $('button.submit-with-agree')
  button.prop({ disabled: true })
  agreeCheck.prop({ disabled: true })

  termWindow.on('scroll', (e) => {
    const threshold = 3
    const target = e.target
    if ((target.scrollHeight - target.clientHeight) - target.scrollTop < threshold) {
      agreeCheck.prop({ disabled: false })
    }
  })

  agreeCheck.on('change', (e) => {
    button.prop({ disabled: !e.target.checked })
  })
})
